import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "./useAuth";
import { login as loginApi } from "../services/api";
import { useToast } from "@chakra-ui/react";

interface LoginData {
    username: string;
    password: string;
}

const useLogin = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { login } = useAuth();
    const toast = useToast();

    const onSubmit = async (data: LoginData) => {
        try {
            const { authToken, refreshToken } = await loginApi(data);
            await login(authToken, refreshToken);
            const returnPath =
                (location.state as { from?: { pathname?: string } } | null)
                    ?.from?.pathname ?? "/";
            navigate(returnPath, { replace: true });
        } catch (error: any) {
            toast({
                title: "Login failed",
                description:
                    error?.message || "Invalid credentials or server error.",
                status: "error",
                duration: 4000,
                isClosable: true,
            });
        }
    };

    return { onSubmit };
};

export default useLogin;
